import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";

class Route {
    public Code: string;
    public DescriptionFr: string;
    public DescriptionEn: string;
    public DescriptionESMX: string;
    public Position: number;

    public static GetLocalizedDescription(r: Route): string {
        if (sessionStore.userLanguageCode == "es-MX")
            return r.DescriptionESMX;
        else if (sessionStore.userLanguageCode == "fr")
            return r.DescriptionFr;
        else
            return r.DescriptionEn;
    }

    public static ToComboboxItem(r: Route): ComboBoxDropDownItem {
        var GroupName = "";
        if (r.Position != null)
            GroupName = cacheStore.GetString("PreferredLabel");
        else
            GroupName = cacheStore.GetString("OtherLabel");

        return new ComboBoxDropDownItem(r.Code, Route.GetLocalizedDescription(r) + " (" + r.Code + ")", r.Position, GroupName);
    }
}

export { Route };
